import React from 'react'
import PropTypes from 'prop-types'

import { withAppContext } from '../../utils/AppContext'
import Card from './Card'
import InputRangeWrap from '../InputRangeWrap'

const TraitsMaesterCard = ({ appContext }) => (
    <Card title="Grand Maester">
        {/* <h3>Qualities You Prize</h3> */}
        <InputRangeWrap
            labelA="Book Smart"
            labelB="Street Smart"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('grandMaesterWeights').book}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'grandMScore' })
                    return appContext.scoreCalculator.onUpdateCategory('book', value, 'grandMaesterWeights')
                }
            }
        />
        <InputRangeWrap
            labelA="Hands-On"
            labelB="Delegates Work"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('grandMaesterWeights').hands}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'grandMScore' })
                    return appContext.scoreCalculator.onUpdateCategory('hands', value, 'grandMaesterWeights')
                }
            }
        />
        <InputRangeWrap
            labelA="Optimist"
            labelB="Pessimist"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('grandMaesterWeights').optimistic}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'grandMScore' })
                    return appContext.scoreCalculator.onUpdateCategory(
                        'optimistic',
                        value,
                        'grandMaesterWeights',
                    )
                }
            }
        />
    </Card>
)

TraitsMaesterCard.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(TraitsMaesterCard)



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/TraitsMaesterCard.js